import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet";
import WhatsAppChatWidget from "../Pages/WhatsAppChatWidget";

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 8;

  useEffect(() => {
    axios
      .get("https://ardorbiomed.com/api/api/blogs")
      .then((response) => {
        setBlogs(response.data || []);
      })
      .catch((error) => console.error("Error fetching blog data:", error));
  }, []);

  const totalPages = Math.ceil(blogs.length / blogsPerPage);
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = blogs.slice(indexOfFirstBlog, indexOfLastBlog);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };
  const pageTitle = "Effective Solutions for Diabetic Ulcer | Ardor Biomed";
  const pageDescription =
    "Discover advanced care and treatment options for diabetic ulcers. Trust Ardor Biomed for expert support and healing-focused solutions.";
  const pageUrl = "https://ardorbiomed.com/Blog";
  const featuredImage = "https://ardorbiomed.com/assets/img/logo-3.png";
  return (
    <>
      <Helmet>
        {/* Primary Meta Tags */}
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <link rel="canonical" href={pageUrl} />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:image" content={featuredImage} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="Ardor Biomed" />
        <meta property="og:locale" content="en_US" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        <meta name="twitter:image" content={featuredImage} />
        <meta name="twitter:site" content="@ardorbiomed" />
        <meta name="twitter:creator" content="@ardorbiomed" />

        {/* Schema.org JSON-LD */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            "headline": "${pageTitle}",
            "description": "${pageDescription}",
            "url": "${pageUrl}",
            "image": "${featuredImage}",
            "author": {
              "@type": "Organization",
              "name": "Ardor Biomed"
            },
            "publisher": {
              "@type": "Organization",
              "name": "Ardor Biomed",
              "logo": {
                "@type": "ImageObject",
                "url": "https://ardorbiomed.com/logo.png"
              }
            },
            "datePublished": "2023-11-15",
            "mainEntityOfPage": {
              "@type": "WebPage",
              "@id": "${pageUrl}"
            }
          }
        `}
        </script>
      </Helmet>
      <div>
        {/* Hero Section */}
        <div className="banner-section  ">
          <img
            src="./assets/img/bannerbreadcrumbs.jpg"
            alt="Banner"
            className="img-fluid banner-img"
          />
          <div className="breadcrumb-container ">
            <h2>Blog</h2>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>

                <li className="breadcrumb-item active" aria-current="page">
                  Blog
                </li>
              </ol>
            </nav>
          </div>
        </div>

        {/* Blog Cards */}
        <section className="container py-5">
          <div className="row g-4">
            {currentBlogs.length > 0 ? (
              currentBlogs.map((blog) => (
                <div className="col-lg-3 col-md-6" key={blog.id}>
                  <div className="card border-0 shadow-sm h-100">
                    <Link
                      to={`/Blogdetail/${blog.id}`}
                      className="overflow-hidden"
                    >
                      <img
                        src={blog.image}
                        className="card-img-top img-fluid"
                        alt={blog.title}
                        style={{ height: "250px", objectFit: "contain" }}
                      />
                    </Link>
                    <div className="card-body">
                      <small className="text-muted">{blog.date} | Admin</small>
                      <h5 className="card-title mt-2">
                        <Link
                          to={`/Blogdetail/${blog.id}`}
                          className="text-dark text-decoration-none"
                        >
                          {blog.title}
                        </Link>
                      </h5>
                      <p className="card-text">
                        {blog.hint && blog.hint.length > 80
                          ? `${blog.hint.substring(0, 80)}...`
                          : blog.hint}
                      </p>
                      <Link
                        to={`/Blogdetail/${blog.id}`}
                        className="btn btn-outline-primary btn-sm"
                      >
                        Read More
                      </Link>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-center w-100">No blogs available.</p>
            )}
          </div>
        </section>

        {/* Pagination */}
        {totalPages > 1 && (
          <nav className="d-flex justify-content-center my-4">
            <ul className="pagination">
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  &laquo;
                </button>
              </li>
              {[...Array(totalPages)].map((_, index) => (
                <li
                  key={index}
                  className={`page-item ${
                    currentPage === index + 1 ? "active" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageChange(index + 1)}
                  >
                    {index + 1}
                  </button>
                </li>
              ))}
              <li
                className={`page-item ${
                  currentPage === totalPages ? "disabled" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  &raquo;
                </button>
              </li>
            </ul>
          </nav>
        )}
      </div>
      <WhatsAppChatWidget
        phoneNumber="+919488828030"
        companyName="Ardor Biomed"
      />
    </>
  );
};

export default Blog;
